export default __webpack_public_path__ + "static/media/logo-no-background.54c30791.png";